import _mixin from '../_mixin'
import _mixinWrap from './_mixinWrap'

export default {
  name: 'STopic2Role',
  cnName: '角色',
  type: 'activity_topic2',
  isTab: true,
  preview: '',
  // 属性相关
  props: {
    bg: {
      src: 'https://rescdn.ssjj.cn/ssjj2res/ssjj2-activity-fe/active/activity-pc/img/fifth-bg.9ef1d6a2.png',
      style: {
        width: '1920px',
        height: '1000px'
      }
    },
    list: [
      {
        img: 'https://rescdn.ssjj.cn/ssjj2res/ssjj2-activity-fe/active/activity-pc/img/role.ae81d452.png',
        thumb: 'https://rescdn.ssjj.cn/ssjj2res/ssjj2-activity-fe/active/activity-pc/img/third-area-first.5da67986.png',
        label: '模式一'
      },
      {
        img: 'https://rescdn.ssjj.cn/ssjj2res/ssjj2-activity-fe/active/activity-pc/img/role_2.544e23fa.png',
        thumb: 'https://rescdn.ssjj.cn/ssjj2res/ssjj2-activity-fe/active/activity-pc/img/third-area-second.8ddaec6b.png',
        label: '模式二'
      }
    ]
  },
  propsDesc: [
    /* 页面属性 */
    ..._mixinWrap.propsDesc,
    {
      target: 'list',
      label: '图片列表',
      formType: 'list',
      listConfig: [
        {
          title: '大图',
          target: 'img'
        },
        {
          title: '缩略图',
          target: 'thumb'
        },
        {
          title: '名称',
          target: 'label'
        }
      ]
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ],
  children: []
}
